import {
  FetchCacheItemSources,
  FetchItemCacheKey,
  FetchItemGqlQuery
} from '../../../../types';
import { TeamNanoID, TeamUUID } from '../../teamsTypes';

import { useCacheShowQuery } from '../../../common/reactQuery/hooks/useCacheShowQuery';

interface CacheTeamResponse<ItemType> {
  team: ItemType | null;
}

interface CacheTeamOptions<ResponseType> {
  action?: string;
  additionalVariables?: Record<string, unknown>;
  cacheKey: FetchItemCacheKey;
  options?: {
    cacheTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
    keepPreviousData?: boolean;
    staleTime?: number;
    onSuccess?: (data: ResponseType) => void;
  };
  query: FetchItemGqlQuery;
  source?: FetchCacheItemSources;
  uuid: TeamUUID | TeamNanoID;
}

interface useCacheTeamItem {
  uuid: TeamUUID;
}

const itemKey = 'team';

function useCacheTeam<ItemType extends useCacheTeamItem>({
  action,
  additionalVariables,
  cacheKey,
  options = {},
  query,
  source = FetchCacheItemSources.DB,
  uuid
}: CacheTeamOptions<CacheTeamResponse<ItemType>>) {
  const {
    item,
    itemError,
    itemErrorData,
    itemFetched,
    itemFetching,
    itemLoading,
    itemIsPlaceholderData,
    updateCacheShowQueryItemCache
  } = useCacheShowQuery<CacheTeamResponse<ItemType>, ItemType>({
    action,
    additionalVariables,
    cacheKey,
    cacheQuery: query,
    itemKey,
    options,
    query,
    source,
    uuid,
    useCacheApiOnly: true
  });

  return {
    team: item,
    teamErrorData: itemErrorData,
    teamError: itemError,
    teamFetched: itemFetched,
    teamFetching: itemFetching,
    teamLoading: itemLoading,
    teamIsPlaceholderData: itemIsPlaceholderData,
    updateTeamCache: updateCacheShowQueryItemCache
  };
}

export default useCacheTeam;
